import './style.scss';

export function product_hero_block () {
    const block = document.querySelector('.product_hero_block ');
    if (!block) return;

}
